var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transfer-selector-item",attrs:{"data-test-id":_vm.dataTestId}},[_c('div',{staticClass:"transfer-selector-item__title"},[_vm._v(" "+_vm._s(_vm.accountType)+" ")]),_c('div',{staticClass:"transfer-selector-item__balance"},[_vm._v(_vm._s(_vm.formattedNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }